import React from "react";
import PropTypes from "prop-types";
import { parseHtml } from "../../utils/utils";

const highlightHtml = (value) => {
  //algolia aa-highlight special tag
  return value.replace(/__aa-highlight__/g, "<mark>").replace(/__\/aa-highlight__/g, "</mark>");
};

const CustomHighlight = ({ attribute, hit }) => {
  const highlightValue = hit._highlightResult[attribute].value;
  const parsedHTML = parseHtml(highlightHtml(highlightValue));

  return <div translate="no">{parsedHTML}</div>;
};

CustomHighlight.propTypes = {
  attribute: PropTypes.string,
  hit: PropTypes.object
};

export default CustomHighlight;
